var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Button, IconButton, InputAdornment, Stack, TextField, Typography, } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNotify } from "react-admin";
import { useTranslation } from "react-i18next";
export var VoterInformationLetterPasswordAccess = function (_a) {
    var pdfPassword = _a.pdfPassword, _b = _a.loading, loading = _b === void 0 ? false : _b, onReveal = _a.onReveal, className = _a.className;
    var t = useTranslation().t;
    var notify = useNotify();
    var copyPassword = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!pdfPassword) {
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, navigator.clipboard.writeText(pdfPassword)];
                case 2:
                    _b.sent();
                    notify(t("tasksScreen.documentAccess.passwordCopied"), { type: "success" });
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    notify(t("tasksScreen.documentAccess.copyError"), { type: "error" });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Stack, { className: ["voter-information-letter-password-access", className]
            .filter(Boolean)
            .join(" "), spacing: 2, alignItems: "flex-start", children: [_jsx(Alert, { className: "voter-information-letter-password-access-warning", severity: "warning", sx: { width: "100%" }, children: t("tasksScreen.documentAccess.sensitivityNotice") }), _jsxs(Typography, { className: "voter-information-letter-password-access-label", variant: "body2", fontWeight: 500, children: [t("tasksScreen.documentAccess.passwordLabel"), ":"] }), !pdfPassword ? (_jsx(Button, { className: "voter-information-letter-password-access-show-button", variant: "outlined", startIcon: _jsx(VisibilityIcon, { className: "voter-information-letter-password-access-show-icon" }), onClick: onReveal, disabled: loading || !onReveal, sx: function (theme) { return ({
                    "alignSelf": "flex-start",
                    "backgroundColor": theme.palette.white,
                    "borderColor": theme.palette.brandColor,
                    "color": theme.palette.brandColor,
                    "&:hover": {
                        backgroundColor: theme.palette.brandColor,
                        borderColor: theme.palette.brandColor,
                        color: theme.palette.white,
                    },
                }); }, children: t("tasksScreen.documentAccess.showPassword") })) : null, _jsx(Typography, { className: "voter-information-letter-password-access-guidance", variant: "body2", color: "text.secondary", children: t("tasksScreen.documentAccess.guidance") }), pdfPassword ? (_jsx(TextField, { className: "voter-information-letter-password-access-field", fullWidth: true, value: pdfPassword, sx: {
                    "maxWidth": 420,
                    "alignSelf": "flex-start",
                    "& input": { fontFamily: "monospace" },
                }, slotProps: {
                    htmlInput: {
                        "aria-label": t("tasksScreen.documentAccess.passwordLabel"),
                        "className": "voter-information-letter-password-access-input",
                    },
                    input: {
                        className: "voter-information-letter-password-access-input-root",
                        readOnly: true,
                        endAdornment: (_jsx(InputAdornment, { className: "voter-information-letter-password-access-copy-adornment", position: "end", children: _jsx(IconButton, { className: "voter-information-letter-password-access-copy-button", onClick: function () { return void copyPassword(); }, edge: "end", "aria-label": t("tasksScreen.documentAccess.copyPassword"), children: _jsx(ContentCopyIcon, { className: "voter-information-letter-password-access-copy-icon" }) }) })),
                    },
                } })) : null] }));
};
